<template>
  <el-container>
    <el-main style="padding: 0; display: flex">
      <div v-if="flag" style="width: 400px">
        <span>批量生产扫描</span>
        <el-divider/>
        <div class="scanContent">
          <div class="left">
            <el-form
                ref="form"
                style="width: 400px"
                :model="model"
                class="form"
                label-width="80px">
              <el-form-item label="工单编号">
                <el-input
                    ref="sBillNo"
                    v-model="model.billNo"
                    placeholder="请输入工单编号"
                    @keyup.enter.native="getWorkCenterData"/>
              </el-form-item>
              <el-form-item label="工单数量">
                <el-input v-model="model.leftQuantity" disabled/>
              </el-form-item>
              <el-form-item label="工作中心">
                <el-input v-model="model.workCenterName" placeholder="请选择工作中心" readonly>
                  <el-button slot="append" @click="$refs.workCenterSelect.open()"> 选择</el-button>
                </el-input>
                <work-center-select ref="workCenterSelect" @select="workCenterSelect"/>
              </el-form-item>
              <el-form-item label="工艺路线">
                <el-input v-model="model.routingName" placeholder="请选择工艺路线" readonly>
                  <el-button
                      slot="append"
                      :disabled="!model.workCenterName"
                      @click="$refs.rtRouteSelect.open(model.workCenterId)">
                    选择
                  </el-button>
                </el-input>
                <rt-route-select ref="rtRouteSelect" @select="rtRouteSelect"/>
              </el-form-item>
              <el-form-item label="生产工序">
                <el-select
                    v-model="poRouter.processName">
                  <el-option
                      v-for="item in model.poRouters"
                      :key="item.processIndex"
                      :value="item.processName"
                      :label="item.processName"
                      @click.native="processIndexChange(item)"
                  />
                </el-select>
              </el-form-item>
              <el-form-item label="操作员工">
                <el-input
                    ref="empNoInput"
                    v-model="employeeNo"
                    placeholder="请扫描员工条码"
                    size="mini"
                    @keyup.enter.native="empNoInput"/>
              </el-form-item>
              <el-form-item label="操作员工名">
                <el-input v-model="model.employeeName" disabled size="mini"/>
              </el-form-item>
              <el-form-item label="扫描工序">
                <el-input
                    ref="processInput"
                    v-model="model.processBarcode"
                    placeholder="请扫描工序"
                    @keyup.enter.native="processInput"/>
              </el-form-item>
            </el-form>
            <el-button
                v-if="model.materialNo !== ''"
                type="primary"
                style="margin-top: 20px"
                @click="$refs.materialBom.open(model.materialNo)">
              查看BOM
            </el-button>
            <el-button
                v-if="processCheck"
                type="primary"
                style="margin-top: 20px"
                @click="processCheckHandle">
              检验
            </el-button>
            <material-bom ref="materialBom"/>
          </div>
        </div>
      </div>
      <div v-if="model.esopId" style="margin-left: 10px; flex: 1">
        <div class="right">
          <!--                    <pdf-preview :pdf-url="model.esopFile" :page-num="+model.esopPageNo" @isFullScreen="isFullScreen"/>-->
          <div style="float: left;">
            <el-button type="primary" @click="isFullScreen()">全屏</el-button>
          </div>
          <pdf-preview ref="pdfRead" :pdf-url="model.url"/>
        </div>
        <!--        <el-button type="primary" style="margin-top: 20px; float: right" @click="$refs.fileUpload.open(model.esopId)">-->
        <!--          Esop修改-->
        <!--        </el-button>-->
        <!--        <esop-change-record ref="fileUpload"/>-->
      </div>
      <inspection-report-edit ref="reportEdit"/>
    </el-main>
  </el-container>
</template>

<script>
  // import PdfPreview from "@/components/PdfPreview";
  import MaterialBom from "@/views/ProductionManagement/ProductionScan/MaterialBom";
  import workCenterSelect from "@/views/information/WorkCenter/WorkCenterSelect";
  import RtRouteSelect from "@/views/information/RtRoute/RtRouteSelect";
  // import EsopChangeRecord from "@/views/ProductionManagement/ProductionScan/EsopChangeRecord";
  import InspectionReportEdit from "@/views/qm/InspectionReport/InspectionReportEdit";
  import PdfPreview from "@/components/PdfPreview1";

  export default {
    name: "PlFinishScanIndex",
    components: {
      MaterialBom,
      workCenterSelect,
      RtRouteSelect,
      PdfPreview,
      // EsopChangeRecord,
      InspectionReportEdit,
    },
    data() {
      return {
        flag: true,
        showButton: true,
        submitLoading: false,
        bindVehicleType: "",
        pdfLoading: false,
        employeeNo: "",
        processCheck: false,
        model: {
          workCenterName: "",
          billNo: "",
          materialNo: "",
          workCenterId: "",
          productionProcessId: "",
          productionProcessName: "",
          processBarcode: "",
          routingName: "",
          routeId: "",
          esopPageNo: 1,
          esopFile: "",
          leftQuantity: 0,
          employeeNo: "",
          employeeName: "",
          poRouters: [],
          url: "",
        },
        poRouter: {
          processIndex: 0,
          processName: "",
          processTypeName: "",
        },
      };
    },

    // mounted() {
    //   this.$refs.refBillNoInput.focus();
    // },

    methods: {
      // 扫描关联编号查询ESOP文件、是否需要绑定载具(0：不绑定载具，1：绑定载具，2：需要载具但不绑定)
      refBillNoInput() {
        if (this.model.refBillNo) {
          this.pdfLoading = true;
          this.$http
            .get("basic", `batchComplete/info?refBillNo=${this.model.refBillNo}`)
            .then((resp) => {
              if (resp.success) {
                this.esopFile = resp.data.esopFile;
                this.esopPageNo = +resp.data.esopPageNo;
                this.bindVehicleType = resp.data.bindVehicleType;
              }
              this.pdfLoading = false;
            })
            .catch(() => {
              this.pdfLoading = false;
            });
        }
      },

      //加载pdf
      loadPdf(url) {
        this.$http.get("basic", `files/getDownloadUrl?key=${encodeURIComponent(url)}`).then((res) => {
          // console.log(res);
          if (res.success) {
            this.model.url = res.data;
          }
        }).catch(() => {
        });
      },

      isFullScreen() {
        this.flag = !this.flag;
        this.showButton = true;
      },
      processIndexChange(item) {
        this.processCheck = false;
        if (item.processTypeName == "检验") {
          this.processCheck = true;
          this.poRouter.processIndex = item.processIndex;
        }
      },
      getWorkCenterData() {
        // this.model.url = "";
        this.$http.get("basic", `taskDispatchBills/getRouteByNo?billNo=${this.model.billNo}`).then((resp) => {
          if (resp.success) {
            let workCenter = resp.data.workCenter;
            let route = resp.data.route;
            this.model.workCenterName = workCenter.workCenterName;
            this.model.materialNo = resp.data.materialNo;
            this.model.workCenterId = workCenter.pkId;
            this.model.routingName = route.routingName;
            this.model.routeId = route.pkid;
            this.model.leftQuantity = resp.data.leftQuantity;
            // this.model.esopFile = resp.data.esopFile;
            this.model.esopId = resp.data.esopId;
            this.model.esopName = resp.data.esopName;
            this.model.esopPageNo = resp.data.esopPageNo ? resp.data.esopPageNo : 1;
            this.model.poRouters = resp.data.poRoutes;

            if (resp.data.poRoutes) {
              this.poRouter.processName = resp.data.poRoutes[0].processName;
              if (this.poRouter != null && this.poRouter.processTypeName == "检验") {
                this.processCheck = true;
              } else {
                this.processCheck = false;
              }
            }

            if (resp.data.esopId) {
              // this.getFileInfoByEsopId(resp.data.esopId);
              this.loadPdf(resp.data.esopFile);
            }
            if (!this.model.employeeNo) {
              this.$refs.empNoInput.focus();
            } else {
              this.$refs.processInput.focus();
            }
          } else {
            this.model.poRouters = [];
            this.poRouter = {
              processIndex: 0,
              processName: "",
              processTypeName: "",
            };
          }
        });
      },
      //检验
      processCheckHandle() {
        const inspectionReport = {
          pkId: 0,
          no: "",
          billNo: this.model.billNo,
          billType: 30,
          checkQuantity: this.model.leftQuantity,
          billTypeName: "",
          materialNo: "",
          materialName: "",
          specification: "",
          billRowIndex: this.poRouter.processIndex,
          note: "",
          resultVOS: [],
        };

        this.$http.post("basic", "inspectionReports/initProcReport", inspectionReport).then((resp) => {
          if (resp.success) {
            this.$refs.reportEdit.open(resp.data, false, false);
          }
        });

      },
      // 选择工作中心
      workCenterSelect(row) {
        this.model.workCenterName = row.workCenterName;
        this.model.workCenterId = row.pkId;
        this.model.routingName = "";
        this.model.routeId = "";
        this.model.productionProcessId = "";
        this.model.productionProcessName = "";
        this.model.sn = "";
      },

      // 根据工作中心选择工艺路线
      rtRouteSelect(row) {
        this.model.routingName = row.routingName;
        this.model.routeId = row.pkid;
        this.model.productionProcessId = "";
        this.model.productionProcessName = "";
        this.model.sn = "";
      },

      // 选择工序
      onProcedureSelect(row) {
        this.model.productionProcessId = row.pkid;
        this.model.productionProcessName = row.processName;
        this.model.esopPageNo = row.esopPageNo ? row.esopPageNo : 1;
        this.model.sn = "";
        // if(row.esopId) {
        //   this.getFileInfoByEsopId(row.esopId);
        // }
      },

      getFileInfoByEsopId(esopId) {
        this.$http.get("basic", `esops/${esopId}`).then((resp) => {
          if (resp.success) {
            this.$http.get("basic", `files/getDownloadUrl?key=${encodeURIComponent(resp.data.filePath)}`).then((res) => {
              if (res.success) {
                this.model.esopFile = res.data;
              }
            });
          }
        });
      },
      empNoInput() {
        if (this.model.employeeNo.includes(this.employeeNo)) {
          return this.$message.error("重复扫描！");
        }
        this.$http.get("basic", "employees/selectByNo/" + this.employeeNo).then((resp) => {
          if (resp.success) {
            if (this.model.employeeNo === "" || this.model.employeeName === "") {
              this.model.employeeNo = resp.data.employeeNO;
              this.model.employeeName = resp.data.employeeName;
            } else {
              this.model.employeeNo = this.model.employeeNo + "," + resp.data.employeeNO;
              this.model.employeeName = this.model.employeeName + "," + resp.data.employeeName;
            }
            this.employeeNo = "";
          } else {
            this.employeeNo = "";
            this.$refs.empNoInput.focus();
          }
        });
      },
      processInput() {
        if (!this.model.workCenterId) {
          this.$confirm("请选择工作中心", "错误", {
            type: "error",
            showCancelButton: false,
          });
          this.model.sn = "";
          return;
        }
        if (!this.model.routeId) {
          this.$confirm("请选择工艺路线", "错误", {
            type: "error",
            showCancelButton: false,
          });
          this.model.sn = "";
          return;
        }
        if (this.model.processBarcode) {
          let params = {
            refBillNo: this.model.billNo,
            workCenterId: this.model.workCenterId,
            routeId: this.model.routeId,
            scannerNo: this.model.employeeNo,
            processBarcode: this.model.processBarcode,
          };
          this.$http.post("basic", "batchComplete/batchComplete", params).then((resp) => {
            this.model.processBarcode = "";
            this.$refs.processInput.focus();

            if (resp.success) {
              console.log(resp);
              this.model.billNo = "";
              this.$refs.sBillNo.focus();
              this.model.leftQuantity = 0;
            }
          });
        }
      },
      // 确认
      scanHandle() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .post("basic", "batchComplete/complete", this.model)
              .then((resp) => {
                if (resp.success) {
                  this.$message.success("批量完工成功");
                  this.reset();
                }
                this.submitLoading = false;
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },

      // 重置
      reset() {
        this.$refs["form"].resetFields();
        this.$refs.sBillNo.focus();
      },
    },
  };
</script>
